export default "/_next/static/images/1-1a55dcf58527db7e0a0510c4750b1107.png";